import BaseValidator from '@/app-core/lib/data/validator/BaseValidator'
import ValidatorTypesEnum from '@/app-core/lib/data/validator/ValidatorTypesEnum'

export default class OtpValidator extends BaseValidator {
  validatorRules = {
    otp: {
      required: true,
      type    : ValidatorTypesEnum.Numeric,
      length  : 6
    },
    type: {
      required: true,
      type    : ValidatorTypesEnum.String,
      isIn    : ['email', 'sms']
    }
  }

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor(data = {}) {
    super(data)
  }
}
